export const applySidebarColor = (color = "success") => {
    const el = document.querySelector("#sidenav-main");
    if (el) {
        el.setAttribute("data-color", color);
    }

    //busca todos los elementos con la clase set-color-button
    const buttons = document.querySelectorAll(".set-color-button");
    if (buttons) {
        buttons.forEach(button => {
            Array.from(button.classList).forEach(clase => {
                if (clase == "btn-success" || clase == "btn-primary" || clase == "btn-secondary" || clase == "btn-info" || clase == "btn-danger" || clase == "btn-warning" || clase == "btn-dark" || clase == "btn-light") {
                    button.classList.remove(clase);
                }
            });
            button.classList.add("btn-" + color);
        });
    }
};